<template>
  <div>
    <select-base
      v-model="valueInner"
      :title-popover="titlePopover"
      :disabled="disabled"
      :multiple="multiple"
      :invalido="invalido"
      :label="label"
      :label-select="'nomeCompleto'"
      :carregar="carregarUsuarios"
      :filtro-adicional="filtroAdicional"
      :filtros="filtros"
      :ignorar-primeiro-acesso="ignorarPrimeiroAcesso"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import api from '@/app-modulo/comuns/usuario-externo/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'UsuarioExternoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    filtro: {
      type: Array,
      default: () => [],
    },
    titlePopover: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: 'Usuário',
    },
    ignorarPrimeiroAcesso: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: null,
      filtros: [
        {
          colunas: ['Nome'],
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.value_ = value
        return this.value_
      },
      get() {
        return this.value_ ? this.value_ : this.value
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (this.filtro && this.filtro.length > 0) {
      this.filtros = this.filtros.concat([...this.filtro])
    }
  },
  methods: {
    carregarUsuarios(filtros) {
      return api.getUsuariosResumidos(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
